import { useState, useEffect } from "react";
import ModalTemplate from "../../../../components/modal/modalTemplate";

const FilesView = ({ show, handleClose, title, files = [], selectedId = 0 }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    // Reset to the correct file when files or selectedId changes
    useEffect(() => {
        if (Array.isArray(files) && files.length > 0) {
            const index = files.findIndex((file) => file.id === selectedId);
            setCurrentIndex(index !== -1 ? index : 0);
        } else {
            setCurrentIndex(0);
        }
    }, [selectedId, files]);

    // If no files, return nothing
    if (!Array.isArray(files) || files.length === 0) return null;

    const currentFile = files[currentIndex];

    // ✅ If currentFile is undefined (edge case during updates), show loading or fallback
    if (!currentFile) {
        return (
            <ModalTemplate
                show={show}
                closeFun={handleClose}
                centered
                title={title}
                body={<p className="text-center py-5">Loading file...</p>}
                footer={null}
            />
        );
    }

    const isImageFile = (fileName = "") => {
        const ext = fileName.split(".").pop()?.toLowerCase();
        return ["jpg", "jpeg", "png", "gif", "webp"].includes(ext);
    };

    const isImage = isImageFile(currentFile.fileName);

    const handleNext = () => {
        setCurrentIndex((prev) => (prev + 1) % files.length);
    };

    const handleBack = () => {
        setCurrentIndex((prev) => (prev - 1 + files.length) % files.length);
    };

    return (
        <ModalTemplate
            show={show}
            closeFun={handleClose}
            centered
            title={title}
            body={
                <div className="card card-plain">
                    <div className="card-header p-2 position-relative z-index-2 bg-transparent text-center">
                        <div className="d-block blur-shadow-image">
                            {isImage ? (
                                <img
                                    src={currentFile.preview}
                                    alt={currentFile.fileName || "file"}
                                    className="img-fluid shadow border-radius-lg w-100"
                                    style={{
                                        maxHeight: "70vh",
                                        objectFit: "contain",
                                        display: "block",
                                        margin: "0 auto",
                                    }}
                                />
                            ) : (
                                <iframe
                                    src={currentFile.preview}
                                    title={currentFile.fileName || "file"}
                                    className="shadow border-radius-lg"
                                    style={{
                                        width: "100%",
                                        height: "70vh",
                                        border: "1px solid #ccc",
                                        borderRadius: "10px",
                                    }}
                                />
                            )}
                        </div>
                    </div>

                    <div className="card-footer d-flex justify-content-between align-items-center p-0 mt-3">
                        <div
                            className="d-flex align-items-center cursor-pointer"
                            onClick={handleBack}
                            style={{ userSelect: "none" }}
                        >
                            <i className="material-icons text-lg me-1">arrow_back</i>
                            <p className="font-weight-bold text-dark my-auto">Back</p>
                        </div>

                        <div
                            className="d-flex align-items-center cursor-pointer"
                            onClick={handleNext}
                            style={{ userSelect: "none" }}
                        >
                            <p className="font-weight-bold text-dark my-auto">Next</p>
                            <i className="material-icons font-weight-bold text-lg ms-1">arrow_forward</i>
                        </div>
                    </div>
                </div>
            }
            footer={null}
        />
    );
};

export default FilesView;